/* Update existing items by incorporating a new item typically received from a subscription.

There 3 scenarios:
- `newItem` is a new item which is not part of `existingItems`
- `newItem` is an updated version of an item in `existingItems`
- `newItem` is already present in `existingItems`

 */
export function updateWithSubscriptionItem<T extends { id: string; deleted: boolean }>({
  newItem,
  existingItems,
  newItemLocation,
}: {
  newItem: T;
  existingItems: T[];
  newItemLocation: 'front' | 'back';
}): T[] {
  const isInExistingItems = existingItems.some((item) => item.id === newItem.id);

  return [
    ...(!isInExistingItems && newItemLocation === 'front' ? [newItem] : []),
    ...existingItems.map((item) => (item.id !== newItem.id ? item : newItem)),
    ...(!isInExistingItems && newItemLocation === 'back' ? [newItem] : []),
  ].filter((item) => !item.deleted);
}
